import type { CheckoutUser } from '@trmediaab/zebra-types/trhub';

import InfoCard from '../Card/InfoCard';

interface LoggedInUserCardProps {
  user: CheckoutUser;
}

const LoggedInUserCard = ({ user }: LoggedInUserCardProps) => (
  <InfoCard
    title="Du är inloggad"
    body={<>Du är inloggad med e-postadress {user.email}</>}
  />
);

export default LoggedInUserCard;
